import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import TasksCreate from "./TasksCreate"
import swal from "sweetalert"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"

const AutoTasks = ({ serviceName, serviceId, savedTasks, frequencyType }) => {
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [tasks, setTasks] = useState([
    {
      id: 1,
      task_name: "",
      frequency: frequencyType === "variable" ? "" : frequencyType,
      dateLabel: "",
      days: "",
      // primaryDesignation: ""
    },
  ])

  useEffect(() => {
    if (savedTasks) setTasks(JSON.parse(savedTasks))
  }, [savedTasks])

  const handleSaveTasks = async e => {
    e.preventDefault()
    try {
      setLoading(true)
      const response = await axiosbaseurl.put(
        `/service-master/auto-tasks/${serviceId}`,
        { autoTasks: JSON.stringify(tasks) }
      )

      if (response.data.success) swal("", "Tasks Saved Successfully", "success")
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button
        onClick={() => {
          setShow(true)
        }}
        className="btn btn-primary  btn-sm me-2"
      >
        <i className="fas fa-list me-1"></i> Auto Tasks
      </button>

      <Modal
        size="xl"
        fullscreen
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <form onSubmit={handleSaveTasks} className="modal-content">
          <ModalHeader className="w-100 bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-4">
              <h5 className="mb-0 text-white">
                {" "}
                Create Tasks for ({" "}
                <span className="text-white">{serviceName}</span> ){" "}
              </h5>
              <div>
                <LoadingButton loading={loading} btn="light" />
                <button
                  type="button"
                  className="btn btn-danger ms-3"
                  onClick={() => setShow(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="px-4">
              <TasksCreate
                tasks={tasks}
                setTasks={setTasks}
                serviceId={serviceId}
                frequencyType={frequencyType}
              />
            </div>
          </ModalBody>
        </form>
      </Modal>
    </>
  )
}

export default AutoTasks
